import React, { useState, useEffect } from "react";
import {
  Button,
  FormControl,
  FormLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@material-ui/core";
import useStyles from "../../../../styles";
import axios from "axios";
import { decryptData } from "../../../../crypto";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { sanitizeInput } from "../../../../Utils/validationUtils";
function AddFacultyForm() {
  const classes = useStyles();

  const decryptedToken = decryptData(sessionStorage.getItem("token"));
  const navigate = useNavigate();
  const [facultyName, setFacultyName] = useState("");
  const [selectedCourse, setSelectedCourse] = useState("");
  const [selectedBatch, setSelectedBatch] = useState("");
  const [courses, setCourses] = useState([]);
  const [batches, setBatches] = useState([]);
  const [orderBy, setOrderBy] = useState("");

  const handleClose = () => {
    navigate("/admin/faculty");
  };

  // const handleCourceChange = (event) => {
  //   setSelectedCourse(event.target.value);
  // };

  // const handleBatchChange = (event) => {
  //   setSelectedBatch(event.target.value);
  // };

  // const menuProps = {
  //   getContentAnchorEl: null,
  //   anchorOrigin: {
  //     vertical: "bottom",
  //     horizontal: "left",
  //   },
  //   disablePortal: true,
  // };

  const handleFormSubmit = () => {
    // const selectedCourseString = String(selectedCourse);
    // const selectedBatchString = String(selectedBatch);

    if (!facultyName.trim()) {
      toast.warn("Please enter a Faculty name.");
      return;
    }
    if (!orderBy.trim()) {
      toast.warn("Please enter a Order By.");
      return;
    }
    // if (!selectedCourseString.trim()) {
    //   toast.warn("Please select a Course.");
    //   return;
    // }
    // if (!selectedBatchString.trim()) {
    //   toast.warn("Please select a Batch.");
    //   return;
    // }


    const data = {
      subject: {
        // course_id: selectedCourse,
        // batch_id: selectedBatch,
        subject_name: facultyName,
        type: "faculty",
        order_by: orderBy !== "" ? Number(orderBy) : null,
      },
    };

    axios
      .post(`${process.env.REACT_APP_API_BASE_URL}/v1/b2b/subject/add`, data, {
        headers: {
          Authorization: `Bearer ${decryptedToken}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        setTimeout(() => {
          navigate("/admin/faculty");
        }, 2000);
        toast.success("Faculty created successfully");
      })
      .catch((error) => {
         const errorMsg = error.response?.data?.message || error.response?.data?.msg || "Faculty is not created";
        toast.error(errorMsg);
      });
  };

  useEffect(() => {
    const fetchCourses = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/course`,
          {
            headers: {
              Authorization: `Bearer ${decryptedToken}`,
            },
          }
        );

        // Ensure that the API response contains the 'batch' property
        if (response.data && response.data.courses) {
          setCourses(response.data.courses);
        } else {
          console.error("Invalid API response format:", response);
        }
      } catch (error) {
        const errorMsg = error.response?.data?.message || error.response?.data?.msg || "Faculty is not created";
        toast.error(errorMsg);
      }
    };

    fetchCourses();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [decryptedToken]);

  return (
    <>
      <ToastContainer />

      <div
        className={`${classes.mt1} ${classes.mt1} ${classes.inputpadding} ${classes.inputborder} ${classes.pagescroll}`}
      >
        <FormControl className={`${classes.w100}`}>
          <div
            className={`${classes.bgwhite} ${classes.boxshadow3} ${classes.borderradius6px} ${classes.py2} ${classes.px1_5} ${classes.mt1}`}
          >
            <div
              className={`${classes.dflex} ${classes.justifyspacebetween} ${classes.mt1}`}
            >
              <Typography
                className={`${classes.w24} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                variant="h6"
                display="inline"
              >
                Faculty Details
              </Typography>
              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w24}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  Faculty Name <span className={classes.textcolorred}>*</span>
                </FormLabel>
                <TextField
                  onChange={(e) => setFacultyName(sanitizeInput(e.target.value, "textInput"))}
                  value={facultyName}
                  type="text"
                  variant="outlined"
                  required
                  placeholder="Enter Faculty Name"
                />
              </div>
              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w24}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  Order By <span className={classes.textcolorred}>*</span>
                </FormLabel>
                <TextField
                  onChange={(e) => setOrderBy(sanitizeInput(e.target.value, "numbersOnly"))}
                  value={orderBy}
                  type="number"
                  variant="outlined"
                  placeholder="Enter Order"
                  inputProps={{ min: 0 }}
                  onWheel={(e) => e.target.blur()}
                />
              </div>
              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w24}`}
              >
                {/* <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  Batch <span className={classes.textcolorred}>*</span>
                </FormLabel>
                <Select
                  labelId="category-label"
                  id="state"
                  value={selectedBatch}
                  onChange={(e) => handleBatchChange(e)}
                  displayEmpty
                  className={classes.selectEmpty}
                  MenuProps={menuProps}
                  variant="outlined"
                >
                  <MenuItem disabled value="">
                 Select Batch
                  </MenuItem>
                  {batches &&
                    batches.map((c) => (
                      <MenuItem key={c.id} value={c.id}>
                        {c.batch_name}
                      </MenuItem>
                    ))}
                </Select> */}
              </div>
            </div>
          </div>
          <div
            className={`${classes.dflex} ${classes.justifyflexend} ${classes.mt1}`}
          >
            <Button
              className={`${classes.custombtnoutline}`}
              onClick={handleClose}
            >
              Cancel
            </Button>
            <Button
              onClick={handleFormSubmit}
              className={`${classes.custombtnblue}`}
            >
              Submit
            </Button>
          </div>
        </FormControl>
      </div>
    </>
  );
}
export default AddFacultyForm;
